import { render, staticRenderFns } from "./participants.vue?vue&type=template&id=91880834&"
import script from "./participants.vue?vue&type=script&lang=js&"
export * from "./participants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports